module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "v5-confirm"
  }, [_c('x-dialog', {
    attrs: {
      "isLockScroll": _vm.isLockScroll
    },
    model: {
      value: (_vm.show),
      callback: function($$v) {
        _vm.show = $$v
      },
      expression: "show"
    }
  }, [_c('div', {
    staticClass: "v5-confirm-content"
  }, [_c('strong', {
    staticClass: "v5-confirm-title"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), (_vm.text) ? _c('div', {
    staticClass: "v5-confirm-message",
    domProps: {
      "innerHTML": _vm._s(_vm.text)
    }
  }) : _c('div', {
    staticClass: "v5-confirm-message"
  }, [_vm._t("default")], 2), _vm._v(" "), _c('div', {
    staticClass: "v5-confirm-footer"
  }, [_c('x-button', {
    staticClass: "v5-confirm-btn",
    attrs: {
      "activeColor": "#ccc"
    },
    on: {
      "on-click": _vm.cancel
    }
  }, [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm.cancelText) + "\n\t\t\t\t")]), _vm._v(" "), _c('x-button', {
    staticClass: "v5-confirm-btn",
    attrs: {
      "activeColor": "#ccc"
    },
    on: {
      "on-click": _vm.confirm
    }
  }, [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm.confirmText) + "\n\t\t\t\t")])], 1)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8e75fc60","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/@58fe/v5/src/components/confirm/index.vue
// module id = 368
// module chunks = 0